import { CustomerTab } from '../../shared/models/customer-tab.model';
import * as TabsActions from '../actions/tabs';

export type State = Array<CustomerTab>;

export const InitialState: State = [
	{
		id: Date.now(),
		selected: true,
		label: 'Kunde #1',
		customerId: null
	}
];

export function reducer (state: State = InitialState, action: TabsActions.All): State {
	switch (action.type) {
		case TabsActions.ADD_TAB:
			return state.concat(action.payload);

		case TabsActions.SELECT_TAB:
			return state.map(tab => ({ ...tab, selected: tab.id === action.payload.id }));

		case TabsActions.REMOVE_TAB:
			return state.filter(tab => tab.id !== action.payload.id);

		case TabsActions.UPDATE_TAB:
			return state.map(tab => tab.id === action.payload.id
				? {
					...tab,
					label: action.payload.label,
					customerId: action.payload.customerId
				}
				: tab
			);

		default:
			return state;
	}
}

export const GetSelectedTab = (s: State): CustomerTab => s.find(tab => tab.selected);



// WEBPACK FOOTER //
// ./src/app/xena/xena-tabs/state-management/reducers/tabs.ts